"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * Holds data about one promotion simulation.
 * @author BPo
 */


var PromotionSimulation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionSimulation, _DomainObject_1$Domai);

  /**
   *
   * @param id internal id of entity
   * @param promotionId internal id of promotion entity
   * @param created time of creation of release entity
   * @param createdBy user who created this release entity
   * @param lastModified time of last modification (last saved)
   * @param lastModifiedBy user who modified this release as last (last saved)
   */
  function PromotionSimulation(id, promotionId, created, createdBy, lastModified, lastModifiedBy) {
    var _this;

    _classCallCheck(this, PromotionSimulation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionSimulation).call(this));
    _this.id = id;
    _this.promotionId = promotionId;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.lastModifiedBy = lastModifiedBy;
    return _this;
  }

  return PromotionSimulation;
}(DomainObject_1.DomainObject);

exports.PromotionSimulation = PromotionSimulation; // tslint:disable-next-line:member-ordering

PromotionSimulation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionSimulation.name);
  return {
    id: builder.id('id'),
    promotionId: builder.id('promotionId'),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    lastModifiedBy: builder.obj('lastModifiedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })
  };
}();